import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-m09__message c-form-inner--wide" }
const _hoisted_2 = { class: "p-the-page-m09__message__text" }
const _hoisted_3 = { class: "p-form-button-group" }
const _hoisted_4 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLink = _resolveComponent("TextLink")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!

  return (_openBlock(), _createBlock(_component_TheTemplateM, {
    class: "p-the-page-m09",
    step: _ctx.step,
    "step-options": _ctx.stepOptions
  }, {
    heading: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode("メールアドレス変更", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _cache[2] || (_cache[2] = _createTextVNode(" ※この段階ではまだメールアドレスの変更は完了していません。 ", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _cache[4] || (_cache[4] = _createTextVNode("ご入力の新しいメールアドレス宛に、【本人認証用URL】を記載したメールを送信しました。 メールに記載された手順にしたがって、30分以内に本人認証を完了させてください。 ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _cache[6] || (_cache[6] = _createTextVNode("メールが届かない場合は、 ", -1)),
          _createVNode(_component_TextLink, {
            href: "/my-page/email-settings/?back_from=email_confirmation",
            "has-underline": true
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("こちらより再度入力情報をご確認ください", -1)
            ])),
            _: 1,
            __: [1]
          }),
          _cache[7] || (_cache[7] = _createTextVNode("。 ", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ButtonMain, {
              tag: 'a',
              href: "/"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("TOPに戻る", -1)
              ])),
              _: 1,
              __: [8]
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["step", "step-options"]))
}